<script>
import Index from "../index.vue"

export default Index
</script>
